import React from 'react'

import {
  Box,
  CircularProgress,
  LinearProgress,
  Theme,
  Typography,
} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    paddingTop: theme.palette.other.constValues.appHeaderHeight, // Using the navbar height to offset
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
}))

type PageLoaderProps = {
  loadingMessage?: string
  position: LoaderPosition
}

type LoaderPosition = 'top' | 'center'

const PageLoader = ({
  loadingMessage,
  position,
}: PageLoaderProps): JSX.Element => {
  const {classes} = useStyles()

  return (
    <Box className={position === 'top' ? classes.root : undefined}>
      {position === 'top' && <LinearProgress color={'primary'} />}
      {position === 'center' && (
        <Box className={classes.wrapper}>
          <Box marginBottom={loadingMessage ? 2 : undefined}>
            <CircularProgress color={'primary'} size={48} />
          </Box>
          <Typography variant={'subtitle2'}>{loadingMessage}</Typography>
        </Box>
      )}
    </Box>
  )
}

export default PageLoader
